<template>
  <div class="product pmt" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">Wsparcie w przygotowaniu Wniosku i SW do EIC
          Accelerator Pilot
        </div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Support in preparation of application and FS
          for EIC Accelerator Pilot
        </div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
            <li>
              <!--                <span class="dot"></span>-->
              <span class="text">
         „Wsparcie Bioseco S.A. w przygotowaniu wniosku oraz studium wykonalności w konkursie EIC Accelerator Pilot”
                </span>
            </li>
            <li>
              <span class="dot"></span>
              <span class="text">
Celem projektu jest zwiększenie innowacyjności i umiędzynarodowienia Spółki poprzez udział w europejskim programie Horyzont 2020 – konkurs EIC Accelerator Pilot.
 </span>
            </li>
            <li>
              <span class="dot"></span>
              <span class="text">
Realizacja projektu pozwoliła na przygotowanie wniosku w ramach programu EIC Accelerator Pilot, opracowanie studium wykonalności, poszukiwania partnerów do projektu, a także udział w panelu eksperckim.
                </span>
            </li>
            <li>
              <span class="dot"></span>
              <span class="text">
Program Operacyjny Inteligentny Rozwój 2014-2020 Działanie: 2.3 Proinnowacyjne usługi dla przedsiębiorstw
Poddziałanie: 2.3.6 Granty na Eurogranty
                  <br/><br/>
                  Wartość projektu:<br/>280 060,00 PLN<br/><br />
                  Wartość dofinansowania:<br/>280 060,00 PLN<br/><br/>
                  Okres realizacji projektu:<br/>02.03.2020 – 31.03.2021<br/>
                </span>
            </li>

          </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <!--                <span class="dot"></span>-->
                <span class="text">
         Support of Bioseco S.A. in the preparation of the application and the feasibility study in the EIC Accelerator Pilot competition
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
The aim of the project is to increase the company's innovation and internationalization by participating in the European program Horizon 2020 - the EIC Accelerator Pilot competition.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
The implementation of the project allowed for the preparation of the application under the EIC Accelerator Pilot program, development of the feasibility study, search for partners for the project, as well as participation in the expert panel.
               </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
Operational Programme Smart Growth 2014-2020; Measure: 2.3; Pro-innovative services for enterprises; Sub-measure: 2.3.6 Grants for Eurogrants
                  <br/><br/>
                  Project value:<br/>280 060,00 PLN<br/><br />
                  Co-financing value:<br/>280 060,00 PLN<br/><br/>
                  Project implementation period:<br/>02.03.2020 – 31.03.2021<br/>
                </span>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      isPageContrasted() {
        return store.state.isPageContrasted
      },
      isFontBigger() {
        return store.state.isPageFontBigger
      },
      smoothScroll: () => smoothScroll
    },

    methods: {},
    mounted: function () {
      store.state.isAccessibilityVisible = true;
      store.state.showPARP = true;
    },
    destroyed: function () {
      store.state.isAccessibilityVisible = false;
      store.state.showPARP = false;
    },
  }
</script>

<style>


  .product.pmt .page-header {
    background: url(/static/img/product/header-area.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
    min-height: 100px;
    padding-bottom: 60px;
  }

  .bps header.page-header .heading-text {
    max-width: 600px;
  }

  .product .why-us-solution .elements .element.bps .text-box {
    float: left;
    max-width: initial;
    margin-top: 20px;
    margin-bottom: 100px;
  }

  .product .why-us-solution .elements .element.bps .text-box ul li .text {
    margin-top: -20px;
  }


  .ue {
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ue img {
    max-width: 940px;
    width: 35%;
  }

  .product.pmt .ue img {
    max-width: 940px;
    width: 50%;
  }

  .product.contrasted {
    background: #000;
    color: yellow;
  }

  .product.contrasted .heading-text {
    color: yellow;
  }

  .product.contrasted .ue {
    background: #000;
  }

  .product.contrasted header a {
    color: yellow;
    background: #000;
  }

  .product.contrasted .btn {
    color: yellow;
    background: #000;
  }

  .product.fontBigger .why-us-solution .elements .element .text-box ul li .text {
    font-size: 1.6em;
    line-height: 1.6em;
  }


</style>



// WEBPACK FOOTER //
// EIC.vue?7623f8f0